import styled from 'styled-components';

import TagSettingBody from '@/features/Setting/Tags/TagsSettingBody';
import { modalStyle } from '@/styles/style';

const TagConfigModal = () => {
  return (
    <Style>
      <TagSettingBody />
    </Style>
  );
};

const Style = styled.div`
  ${modalStyle};
  height: 90vh;
  width: 600px;
`;

export default TagConfigModal;
